import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { LineBreak } from '~/core/tableColumns/scheduleTableColumns/styles';

export const Text = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle3};
    color: ${({ theme }) => theme.Text.secondary};

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.desktop.subtitle2};
    }
`;

export const PromoContainer = styled.div<{ $hasGap?: boolean }>`
    display: flex;

    ${({ $hasGap }) =>
        $hasGap &&
        css`
            ${BaseStyle.Mixins.gaps.semiMedium};
        `}
`;

export const PromoHeader = styled(Text)`
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        flex: initial;
    }
`;

export const WatchContainer = styled.div<{ $hasGap?: boolean }>`
    align-items: center;
    display: flex;
    flex: 1;

    ${({ $hasGap }) =>
        $hasGap &&
        css`
            ${BaseStyle.Mixins.gaps.semiMedium};
        `}
`;

export const WatchHeader = styled(Text)`
    min-width: fit-content;
`;

export const Divider = styled(LineBreak)`
    height: 34px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        height: 24px;
    }
`;

export const PromoImage = styled.img`
    height: 24px;
`;
